import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { QRCodeSVG } from 'qrcode.react';

class QRCode extends Component {
  render() {
    const { sale_id } = this.props
    return(
      <QRCodeSVG value={sale_id} />
    )
  }
}

QRCode.propTypes = {
  sale_id: PropTypes.string.isRequired,
}

export default QRCode




